import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

// 1. ロゴ画像を '@' を使った絶対パスで import する
import logoImage from '@/src/assets/images/AgLab_logo.png';

// 2. Logoコンポーネントを <img> タグに変更する
const Logo: React.FC = () => (
  <img src={logoImage} alt="AgLab Logo" style={{ width: '120px', height: 'auto' }} />
);

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Close mobile menu on route change
    setIsMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const NavItems: React.FC = () => (
    <>
      <Link to="/service" className="px-4 py-2 text-gray-700 hover:text-[#3aabd2] transition-colors duration-300">Service</Link>
      <Link to="/company" className="px-4 py-2 text-gray-700 hover:text-[#3aabd2] transition-colors duration-300">Company</Link>
      <Link to="/case-study" className="px-4 py-2 text-gray-700 hover:text-[#3aabd2] transition-colors duration-300">Case Study</Link>
      <Link to="/news" className="px-4 py-2 text-gray-700 hover:text-[#3aabd2] transition-colors duration-300">News</Link>
      <Link to="/recruit" className="px-4 py-2 text-gray-700 hover:text-[#3aabd2] transition-colors duration-300">Recruit</Link>
      <Link to="/contact" className="px-4 py-2 text-gray-700 hover:text-[#3aabd2] transition-colors duration-300">Contact</Link>
    </>
  );

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled || isMenuOpen ? 'bg-white/90 shadow-md backdrop-blur-sm' : 'bg-transparent'}`}>
      <div className="w-full max-w-screen-2xl mx-auto px-6 md:px-8 py-4 flex justify-between items-center">
        <Link to="/" onClick={() => setIsMenuOpen(false)}>
          <Logo />
        </Link>
        
        <nav className="hidden md:flex items-center space-x-4">
          <NavItems />
        </nav>
        
        <div className="md:hidden">
          <button onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Open menu" className="z-50 relative">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16m-7 6h7"}></path>
            </svg>
          </button>
        </div>
      </div>
      
      <nav className={`md:hidden transition-all duration-300 ease-in-out ${isMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'} overflow-hidden`}>
        <div className="bg-white flex flex-col items-center py-4 border-t border-gray-200">
          <NavItems />
        </div>
      </nav>
    </header>
  );
};

export default Header;